import * as React from 'react';
import { DatePicker as DesignDatePicker } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const DatePicker = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignDatePicker {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default DatePicker;
